const videoEnhancer = {
  HitPawOnlineAIVideoEnhance: 'HitPaw Online AI Video Enhance',
  ProcessingLimit: '처리 제한:{{num}}',
  AllModelsAreAvailable: '모든 모델을 사용할 수 있음.',
  SupportAllSubdivisionRateExport: '모든 세분화 비율 내보내기 지원.',
  SupportPreviewVideo: '미리 보기 비디오 지원.',
  BatchProcessingComingSoon: '일괄 처리(커밍 순).',
  CancelAnytime: '언제든지 취소됨.',
  highPriorityProcessingSpeed: '높은 우선순위 처리 속도.',
  YearDayPrice: '₩600',
  YearTotalPrice: '₩218,999',
  MonthTotalPrice: '₩30,999',
  MonthDayPrice: '₩1,033',
  WeekTotalPrice: '₩11,999',
  WeekDayPrice: '₩1,714',
  Day: '일',
  Monthly: '월',
  Weekly: '주',
  Yearly: '년',
};

export default videoEnhancer;
